export interface RunState {
  score: number;
  stageScore: number;
  combo: number;
  hits: number;
  totalAttempts: number;
  stageIndex: number;
  timeRemainingMs: number;
  lastHitTimeMs: number;
  lastActivityTimeMs: number;
  isBoostActive: boolean;
}

export function createInitialRunState(): RunState {
  return {
    score: 0,
    stageScore: 0,
    combo: 1,
    hits: 0,
    totalAttempts: 0,
    stageIndex: 0,
    timeRemainingMs: 0,
    lastHitTimeMs: 0,
    lastActivityTimeMs: 0,
    isBoostActive: false,
  };
}
